import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import { UtilService } from './util-service';
import { Cargo } from '../models/Cargo';
import { GestaoPcaService } from './gestao-pca-service';

@Injectable()
export class CargoService {

  constructor(http: HttpClient, private utilService: UtilService, private gestaoPcaService: GestaoPcaService, ) {
  }

  public criaCargo() {
    return new Cargo();
  }

  public listar(idModulo: any): Observable<any> {
    let urlObtencaoDados: string = "cargo/listar?idModulo=" + idModulo + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarAtivo(idModulo: any): Observable<any> {
    let urlObtencaoDados: string = "cargo/listarAtivo?idModulo=" + idModulo + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarCargoSAP(idModulo: any): Observable<any> {
    let urlObtencaoDados: string = "cargo/listarCargosSAP?idModulo=" + idModulo + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarCargo(idModulo: any): Observable<any> {
    let urlObtencaoDados: string = "cargo/listarCargos?idModulo=" + idModulo + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarCargoAtivo(idModulo: any): Observable<any> {
    let urlObtencaoDados: string = "cargo/listarCargosAtivos?idModulo=" + idModulo + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarCargo(idCargo): Observable<any> {
    let urlObtencaoDados: string = "cargo/obter?idCargo=" + idCargo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarLista(listObjects: Array<any>): Observable<any> {
    let urlObtencaoDados: string = "cargo/salvarLista";
    return this.utilService.postJSON(urlObtencaoDados, JSON.stringify(listObjects));
  }

  public salvarNovoCargo(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "cargo/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public deletarCargo(idCargo): Observable<any> {
    let urlObtencaoDados: string = "cargo/deletar?idCargo=" + idCargo;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarLista(jsonList): Observable<any> {
    let urlObtencaoDados = "cargoExclusao/excluirLista";
    return this.utilService.postJSON(urlObtencaoDados, jsonList);
  }

  public salvarAnaliseRelacaoCargos(idPca: any, cdAnalise: any): Observable<any> {
    let params = "";
    let urlObterQuestoes = "cargo/salvarAnaliseRelacaoCargos?idPca=" + idPca + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObterQuestoes, params);
  }

  public finalizarAnaliseRelacaoCargos(idPca: any, cdAnalise: any): Observable<any> {
    let params = "";
    let urlObterQuestoes = "cargo/finalizarAnaliseRelacaoCargos?idPca=" + idPca + "&cdAnalise=" + cdAnalise;
    return this.utilService.postJSON(urlObterQuestoes, params);
  }

  public carregarCargosAnoAnterior(idModulo: any): Observable<any> {
    let urlObterQuestoes = "cargo/carregarCargosAnoAnterior?idModulo=" + idModulo + "&idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObterQuestoes);
}

}



// WEBPACK FOOTER //
// ./src/providers/cargo-service.ts